import React, { useState, useContext, useEffect } from "react";
import { Web3Context } from "./Context/Web3context";
import { Component } from "react";
import "./components/Stake.css";
import './Raffle.css'
import CopyToClipboard from "react-copy-to-clipboard";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Countdown from 'react-countdown';
import raffleticket from './images/raf2.svg'
import buybg from './images/butbutton.svg'
import clock from './images/clock.png'
import teamNamePlate from './images/teamNamePlate.png'
import { rafABI, Ierc20 } from "./Contract/abi/abi"
import { raffleAdd, FKToken, } from "./Contract/constant"
import Loader from "react-loader";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import silver from './images/m2.svg'
import gold from './images/gol.svg'
import bronz from './images/bronz.svg'
import cross from './images/cross.svg'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const truncate = (str, n) => {
    return (
        str.substr(0, n + 1) + "..." + str.substr(str.length - n, str.length)
    );
};

function Raffle() {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [trahash, setTrahash] = useState();
    const [loaded, setLoaded] = useState(true);
    const state = useContext(Web3Context);
    const [quantity, setQuantity] = useState(0)
    const [usersTickets, setUsersTickets] = useState(0)
    const [selectedToken, setSelectedToken] = useState("FUKU")
    const [buySuccess, setBuySuccess] = useState(false)
    const [soldTickets, setSoldTickets] = useState(0)
    const [acc,setAcc] = useState();

    const claimABI = [{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"investor","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"DepositInvestment","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"investor","type":"address"},{"indexed":true,"internalType":"address","name":"caller","type":"address"},{"indexed":false,"internalType":"uint256","name":"allocation","type":"uint256"}],"name":"InvestorAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"investor","type":"address"},{"indexed":true,"internalType":"address","name":"caller","type":"address"},{"indexed":false,"internalType":"uint256","name":"allocation","type":"uint256"}],"name":"InvestorRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address[]","name":"investors","type":"address[]"},{"indexed":false,"internalType":"uint256[]","name":"tokenAllocations","type":"uint256[]"},{"indexed":false,"internalType":"address","name":"caller","type":"address"}],"name":"InvestorsAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"token","type":"address"},{"indexed":true,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"RecoverToken","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"TransferInvestment","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"investor","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"WithdrawnTokens","type":"event"},{"inputs":[{"internalType":"address[]","name":"_investors","type":"address[]"},{"internalType":"uint256[]","name":"_tokenAllocations","type":"uint256[]"}],"name":"addInvestors","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getInitialTimestamp","outputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"investors","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"investorsInfo","outputs":[{"internalType":"bool","name":"exists","type":"bool"},{"internalType":"uint256","name":"withdrawnTokens","type":"uint256"},{"internalType":"uint256","name":"tokensAllotment","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isFinalized","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isInitialized","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"recoverToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"releaseTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_timestamp","type":"uint256"}],"name":"setInitialTimestamp","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_investor","type":"address"}],"name":"withdrawableTokens","outputs":[{"internalType":"uint256","name":"tokens","type":"uint256"}],"stateMutability":"view","type":"function"}];
    const claimAddr = "0xD6BB77A5af052AD69E640ffab38b4D1656e2A4B6";
    //const winningTickets = [453,464,176];
    const winners =[{"ticket":453,"address":"0x36f700348d4cf54dc4a1807108891735d101eaEc"},{"ticket":464,"address":"0x36f700348d4cf54dc4a1807108891735d101eaEc"},{"ticket":176,"address":"0x7125F1f554fC331952c4aAEeAd6f0C3e29483E26"}];
    function setQuantityExt(e) {
        const newValue = Math.ceil(e.target.value)
        setQuantity(previousValue => newValue)
    }
    function handleBuy() {
        setBuySuccess(true)
    }
    function handleChange(e) {
        setSelectedToken(e.target.value);
    }
    /**        raf.methods.totalSupply().call({ from: state.address }).then((r) => {
                let _tvl = state.web3.utils.fromWei(r.toString(), "ether");
                _tvl = parseFloat(_tvl).toFixed(3);
              }) */

    /**Get Ticket baland total ticket sold */
    const _getTotalTicket = () => {

        if (state !== undefined) {
            const raf = new state.web3.eth.Contract(rafABI, raffleAdd);
            raf.methods.totalSupply().call({ from: state.address }).then((r) => {

                console.log(r)
                setSoldTickets(r)
            })
        }
    }
    const _getTicketBal = (a) => {
        const raf = new state.web3.eth.Contract(rafABI, raffleAdd);
        raf.methods.balanceOf(a).call({ from: state.address }).then((r) => {
            console.log(r);
            setUsersTickets(r);
        })
    }
    const _claim = (a) => {
        const cla = new state.web3.eth.Contract(claimABI, claimAddr);
        cla.methods.withdrawTokens().send({ from: state.address }).then((r) => {
            console.log(r);
           // setUsersTickets(r);
        })
    }
    /**Buy tickets with BNB, 1 ticket = 0.025bnb */

    const _buyTktBNB = () => {
        setLoaded(false)
        if (state !== undefined) {
            const raf = new state.web3.eth.Contract(rafABI, raffleAdd);
            let v = quantity * 0.025;
            v = state.web3.utils.toWei(v.toString(), 'ether');
            raf.methods.mintTicketsBNB(quantity).send({ from: state.address, value: v }).then((r) => {
                setBuySuccess(true)
                setLoaded(true)
                setOpen(true)
                console.log(r)
                setTrahash(r.transactionHash)
            })
        }
    }

    /**Buy tickets with Fuku, 1 ticket = 0.025bnb */

    const _buyTktFuku = (value) => {
        setLoaded(false)
        if (state !== undefined) {
            const raf = new state.web3.eth.Contract(rafABI, raffleAdd);
            const appr = new state.web3.eth.Contract(Ierc20, FKToken);
            let v = quantity * 10000;
            v = state.web3.utils.toWei(v.toString(), 'ether');
            appr.methods.approve(raffleAdd, v).send({ from: state.address }).then((t) => {
                raf.methods.mintTicketsFuku(quantity).send({ from: state.address }).then((r) => {
                    setBuySuccess(true)
                    setLoaded(true)
                    setOpen(true)
                    console.log(r)
                    setTrahash(r.transactionHash)
                })
            })
        }
    }

    useEffect(() => {
        if (state !== undefined) {
            _getTicketBal(state.address);
            _getTotalTicket();
            setAcc(state.address);
        }
    }, [state])

    const getTeamsCard = (isDown, headerText, pic, names, details,addr) => {
        return (
            <div className={isDown ? "teams-card-div " : "teams-card-div down-card"}>
                <div className="team-header">
                    <p>{headerText}</p>
                </div>
                <div className="team-picture">
                    <img src={pic} alt="" />
                </div>
                <p className="teammember">{names}</p>
                <p className="teammember-details">{details}</p>
                {state?<>
                {acc == addr?
                <div className="buybtn">
                    <img src={buybg} alt="buy btn" className="btn-buy" />
                    <p className="claimbtntext" onClick={_claim}>Claim</p>
                </div>:""}</>:""}
            </div>
        );
    }
    return (
        <div className="stake">
            {/* <div className="countdown-container stake_container">
                <div className="closed-counter">
                    <h1 className="pot">Ticket counter has been clossed</h1>
                    <h4 className="pot1">The winners of the lucky draw will be announced at 6pm UTC</h4>
                </div>
            </div>  */}
            <div className="teammember-div">
                <h1 className="team-title">Winners</h1>
                <h5 className="pot1 stake_container">Connect wallet to claim. Rewards will be distributed for linear 30 days </h5>
                <div className="team-div">
                    {getTeamsCard(false, "Silver Medalist", silver, truncate(winners[1].address, 5), "Ticket No:"+winners[1].ticket.toString(),winners[1].address)}
                    {getTeamsCard(true, "Gold Medalist", gold, truncate(winners[0].address, 5), "Ticket No:"+winners[0].ticket.toString(),winners[0].address)}
                    {getTeamsCard(false, "Bronze Medalist", bronz, truncate(winners[2].address, 5), "Ticket No:"+winners[2].ticket.toString(),winners[2].address)}
                </div>
            </div>
            {/* 
             <div className="countdown-container stake_container">
                <div className="countdown-left ">
                    <img src={teamNamePlate} alt="total sold tickets" className="btn-totalsold" />
                    <p className="total-sold ">Total tickets Sold: <b style={{ color: "#fff" }}>{soldTickets}</b></p>
                    <img src={teamNamePlate} alt="total bought tickets" className="btn-totalbought" />
                    <p className="total-bought ">Total tickets bought: <b style={{ color: "#fff" }}>{usersTickets}</b></p>
                </div>
                <div className="countdown-right">
                    <div className="countdown-div">
                        <div className="clock">
                            <img src={clock} alt="" className="clock" />
                        </div>
                        <div className="cdown">
                            <Countdown date={1639144800000} className="countdown" />
                            <p className="countdown-lbl">DD:HH:MM:SS</p>
                        </div>
                    </div>
                    <p className="pot1 stake_container"> Pot Amount: <b style={{ color: "#fff", padding: "1px 10px" }}> 15,000,000 </b>$FUKU</p>
                </div>
            </div>
           <div className="row card-wrapper raffle-wrapper">
                <div className="raffle-div">
                    <div className="ticket-wrapper">
                        <img src={raffleticket} alt="raffle ticket" className="raffle-ticket" />
                    </div>
                    <div className="buy-wrapper">
                        <div className="dd-wrapper">
                            <select onChange={(e) => handleChange(e)} className="tokendropdown stake_container" >
                                <option value="FUKU" className="tokendropdownopt" >FUKU</option>
                                <option value="BNB" className="tokendropdownopt" >BNB</option>
                            </select>
                        </div>
                        <div className="row-2">
                            <p className="pot">{selectedToken === "FUKU" ? "10000 FUKU/ticket" : "0.025 BNB / ticket"}</p>
                            <span className="multi"> X </span>
                            <input type="text" className="text-qty" value={quantity} onChange={(e) => setQuantityExt(e)} placeholder="Enter Quantity" />
                            <span className="multi"> = </span>
                            <p className="pot"><b> {quantity * (selectedToken === "FUKU" ? 10000 : 0.025)}</b> {selectedToken === "FUKU" ? "FUKU" : "BNB"}</p>
                        </div>
                        {
                            selectedToken === "FUKU" ?

                                //is Approved?
                                <div className="buybtn">
                                    <img src={buybg} alt="buy btn" className="btn-buy" />
                                    <p className="buybtntext" onClick={_buyTktFuku}>Buy with FUKU</p>
                                </div>
                                :
                                <div className="buybtn">
                                    <img src={buybg} alt="buy btn" className="btn-buy" />
                                    <p className="buybtntext" onClick={_buyTktBNB}>Buy with BNB</p>
                                </div>
                        }
                    </div>
                </div>

            </div>
            {buySuccess &&
                <div className="col wnc-div" >
                    <h2 className="wallet-not-connected">{quantity} Tickets bought successfully.</h2>
                </div>
            }
            {
                 <Modal
                 open={open}
                 onClose={handleClose}
                 aria-labelledby="modal-modal-title"
                 aria-describedby="modal-modal-description"
               >
                 <Box sx={style}>
                   <Typography id="modal-modal-title" variant="h6" component="h2" className="modal-title">
                     <p>Transaction Successfull</p>
                     <p className="close-btn" onClick={handleClose}>X</p>
                   </Typography>
                   <div className="ticket-wrapper">
                        <img src={raffleticket} alt="raffle ticket" className="raffle-ticket-modal" />
                    </div>
                   <Typography id="modal-modal-description" sx={{ mt: 2 }}  className="modal-pot">
                     <b>{quantity} </b> Tickets bought successfully.
                     </Typography>
                     <p className="modal-text">Transaction: <a href={"https://bscscan.com/tx/"+ trahash} target="blank">{trahash?truncate(trahash, 5):'' }</a></p>
                 </Box>
               </Modal>
            }
            <Loader
        loaded={loaded}
        lines={13}
        length={20}
        width={10}
        radius={30}
        corners={1}
        rotate={0}
        direction={1}
        color="#fff"
        speed={1}
        trail={60}
        shadow={false}
        hwaccel={false}
        className="spinner"
        zIndex={2e9}
        top="50%"
        left="50%"
        scale={1.0}
        loadedClassName="loadedContent"
      />
        </div> */}
        </div>
    );

};

export default Raffle;
